import Keycloak from 'keycloak-js';
import constants from './core/constants';

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak(constants.KEYCLOAK);

export default keycloak;
